<template>
  <div class="ksapcx-main">
    <Header title="考试安排查询"></Header>
    <van-sticky :offset-top="50">
      <div class="examSchedule_select">
        <!-- 学年学期 -->
        <div class="sem-drop">
          <div @click="showPop('学年学期', 'xnxq')">
            <p>{{ xnxq.mc }}</p>
            <i></i>
          </div>
        </div>
        <!-- 学期类别 -->
        <div class="sem-drop">
          <div @click="showPop('学期类别', 'xqlb')">
            <p>{{ xqlb.mc }}</p>
            <i></i>
          </div>
        </div>
      </div>
    </van-sticky>
    <NOdata v-if="list.length == 0" title="暂无数据~"></NOdata>
    <div v-else class="qz-list">
      <div
        class="qz-list-item"
        v-for="(item, index) in list"
        :key="index"
        @click="goDetail(item)"
      >
        <div class="qz-list-item-content">
          <div class="qz-list-item-text">
            <h4 class="qz-list-item-title">{{ item.KCMC }}[{{ item.KCH }}]</h4>
          </div>
          <p class="qz-list-item-link">详情<van-icon name="arrow" /></p>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import tApi from "../../../../utils/teacher";
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      list: [],
      xnxq: {},
      xqlb: {},
      show: false,
      columns: {
        jxzcXq: [],
        jc: []
      },
      valueList: {
        label: "",
        value: "",
        item: []
      }
    };
  },
  components: {},
  created() {
    this.getXnxq();
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: "/ksapcx/detail",
        query: {
          list: item
        }
      });
    },
    async getList() {
      const res = await tApi.getKsapcx({
        xnxqid: this.xnxq.dm,
        xqlb: this.xqlb.dm
      });
      this.list = res.data;
    },
    // 获取学年学期
    async getXnxq() {
      let xnxqDefaultIndex = 0;
      const res = await Api.getXnxq();

      this.columns.xnxq = [
        {
          values: res.data.map((item, index) => {
            if (item.isdqxq === "1") {
              xnxqDefaultIndex = index;
              this.xnxq = {
                dm: item.xnxq01id,
                mc: item.xqmc
              };
            }
            return {
              value: item.xnxq01id,
              text: item.xqmc
            };
          }),
          defaultIndex: xnxqDefaultIndex
        }
      ];
      this.getXqlb();
    },
    async getXqlb() {
      let xqlbDefaultIndex = 0;
      const res = await tApi.get_xqlb();
      this.columns.xqlb = [
        {
          values: res.data.map((item, index) => {
            if (index === 0) {
              xqlbDefaultIndex = index;
              this.xqlb = {
                dm: item.dm,
                mc: item.dmmc
              };
            }
            return {
              value: item.dm,
              text: item.dmmc
            };
          }),
          defaultIndex: xqlbDefaultIndex
        }
      ];
      this.getList();
    },
    // 弹出选择器
    showPop(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value[0].text;
      this[value1].dm = value[0].value;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.ksapcx-main {
  background-color: #f2f2f4;
  height: 100%;
  .examSchedule_select {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    // border-bottom: 1px solid @attendance-border-color-6;
    .sem-drop {
      > div {
        display: flex;
        align-items: center;
        color: @attendance-color-2;
        font-size: 14px;
        i {
          background: url(../../../../../static/img/Triangle.png) no-repeat
            center;
          width: 10px;
          height: 10px;
          background-size: 10px 8px;
          margin-left: 5px;
        }
      }
    }
    select {
      background: none;
      border: 0;
      outline: 0;
    }
    /deep/.van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
      color: @attendance-color-1;
      font-weight: 600;
    }
    /deep/.van-dropdown-menu__title--active {
      color: @attendance-color-2;
    }
    /deep/.van-popup {
      max-height: 40%;
    }
    /deep/.van-hairline--top-bottom:after,
    .van-hairline-unset--top-bottom:after {
      border-width: 0;
    }
  }
  .van-popup--center {
    border-radius: 8px;
    .examSchedule-pop-info {
      width: 311px;
      height: 410px;
      background: #ffffff;
      overflow: scroll;
      padding: 143px 0 50px 0;
      box-sizing: border-box;
      .top {
        width: 100%;
        height: 123px;
        background: url(../../../../../static/img/card_bg4.png) no-repeat center;
        background-size: 100% 100%;
        color: #fff;
        padding: 26px 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
        position: absolute;
        top: 0;
        left: 0;
        .title {
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 6px;
        }
        .label {
          font-size: 14px;
          line-height: 20px;
          color: #ecebff;
        }
      }
      .info-label {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        margin: 0 20px 5px 20px;
      }
      .examSchedule-pop-info-button {
        height: 46px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        border-top: 1px solid #ebedf0;
        // margin: 0 7px;
        .van-button {
          width: 100%;
          height: 100%;
          font-size: 14px;
          color: #7469f8;
          border: none;
        }
      }
    }
  }
  .qz-list {
    padding: 0 15px 10px;
    background-color: #f2f2f4;

    .qz-list-item {
      border-radius: 6px;
      margin-top: 10px;
      background-color: #fff;
      padding: 16px 15px;
      line-height: 20px;

      .qz-list-item-content {
        display: flex;
        align-items: center;
        position: relative;

        .qz-list-item-icon {
          width: 40px;
          height: 40px;
        }

        .qz-list-item-text {
          margin-left: 9px;

          .qz-list-item-title {
            font-size: 16px;
            color: @attendance-color-8;
            line-height: 22px;
          }

          .qz-list-item-label {
            font-size: 14px;
            color: #999999;
            font-weight: Medium;
            margin-top: 6px;
            line-height: 20px;
          }
        }

        .qz-list-item-link {
          color: @attendance-background-color-1;
          font-size: 14px;
          position: absolute;
          right: 0;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/ksapcx/index.vue